// The readable rendering of a stored cron expression. It lives on the client
// because the sentence is user-facing copy and must come out of Tolgee in the
// interface language (AGENTS.md R3); the server returns the expression and the
// next fire time, never a translated string.
export type ScheduleDescription =
  | { kind: 'daily'; time: string }
  | { kind: 'weekly'; day: number; time: string }
  | { kind: 'everyHours'; hours: number }
  | { kind: 'everyMinutes'; minutes: number }
  | { kind: 'custom' };

const NUMERIC = /^\d+$/;

function timeOf(minute: string, hour: string): string {
  return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
}

export function describeSchedule(expression: string): ScheduleDescription {
  const fields = expression.trim().split(/\s+/);
  if (fields.length !== 5) {
    return { kind: 'custom' };
  }
  const [minute, hour, dayOfMonth, month, dayOfWeek] = fields as [
    string,
    string,
    string,
    string,
    string,
  ];
  if (dayOfMonth !== '*' || month !== '*') {
    return { kind: 'custom' };
  }
  if (hour === '*' && minute.startsWith('*/') && NUMERIC.test(minute.slice(2))) {
    return { kind: 'everyMinutes', minutes: Number(minute.slice(2)) };
  }
  if (!NUMERIC.test(minute)) {
    return { kind: 'custom' };
  }
  if (hour.startsWith('*/') && NUMERIC.test(hour.slice(2))) {
    return { kind: 'everyHours', hours: Number(hour.slice(2)) };
  }
  if (!NUMERIC.test(hour)) {
    return { kind: 'custom' };
  }
  if (dayOfWeek === '*') {
    return { kind: 'daily', time: timeOf(minute, hour) };
  }
  if (NUMERIC.test(dayOfWeek)) {
    return { kind: 'weekly', day: Number(dayOfWeek) % 7, time: timeOf(minute, hour) };
  }
  return { kind: 'custom' };
}
